import React from "react";
import styled from "styled-components";
import Select from "react-select";

const Component = props => {
    return (
        <StyledSelect
            {...props}
            classNamePrefix="select"
            theme={theme => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: "#de0606",
                    primary25: "rgba(222,6,6,.3)",
                    primary50: "rgba(222,6,6,.5)"
                }
            })}
        />
    );
};
const StyledSelect = styled(Select)`
    position: relative;
    min-width: ${({ minWidth }) => (minWidth ? minWidth : "200px")};
    margin: ${({ margin }) => margin};
    /* z-index: 5000; */
    .select__single-value {
        color: #979797;
    }
    .select__placeholder {
        color: #979797;
    }
    .select__option--is-focused {
        color: #fff;
    }
    .select__menu-list {
        position: relative;
        /* z-index: 6000; */
    }
    @media (max-width: 665px) {
        font-size: 16px;
    }
`;
export default Component;



// WEBPACK FOOTER //
// ./src/dev/Select.js